import React, { useContext, useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CRow,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CTableRow,
  CTableHeaderCell,
  CTable,
  CTableBody,
  CTableDataCell,
  CBadge,
  CCardBody,
  CTableHead,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import DownloadExcel from "src/reusables/DownloadExcel";
import { DataGrid } from "@mui/x-data-grid";
import formatter from "src/reusables/formatter";
import { getAll, getDetails } from "src/services/WorkPlans";
import { Toaster } from "src/components/Toaster";
import { format, isWeekend } from "date-fns";
import ls from "local-storage";
import Authentication, { AUTH_KEY } from "src/utils/auth/Authentication";
import { AuthContext } from "src/App";
import Moment from "moment";
import { DateRangePicker } from "react-date-range";
import { useLocation, useNavigate } from "react-router-dom";

function WorkPlans() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0);
  const [userID, setUserID] = useState(0);
  const [detailModal, setDetailModal] = useState(false);
  const [selectedWP, setSelectedWP] = useState({});
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const location = useLocation();
  const [visitationModal, setVisitationModal] = useState(false);
  const [selectedVisitation, setSelectedVisitation] = useState(null);
  function handleVisitationClick(visitation) {
    console.log("Visitation clicked:", visitation);
    setSelectedVisitation(visitation);
    setVisitationModal(true);
  }
  const useWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    const comparison = width / height;
    const [windowDimensions, setWindowDimensions] = useState({
      width,
      height,
      comparison,
    });

    useEffect(() => {
      function handleResize() {
        const { innerWidth: width, innerHeight: height } = window;
        const comparison = width / height;
        setWindowDimensions({ width, height, comparison });
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width, comparison } = useWindowDimensions();

  const [drModal, setDrModal] = useState(false);
  const endDay = Moment(new Date()).format("YYYY-MM-DD");
  const max = new Date(endDay);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf("month")}`),
      endDate: new Date(),
    },
  ]);

  async function fetchDetails(id) {
    const res = await getDetails(id);
    setDetails(res.details);
  }
  const formatTime = (time) => {
    if (!time) return <CBadge color="secondary">Belum</CBadge>;
    return time;
  };

  // Calculate visit status
  const getVisitStatus = (detail) => {
    if (!detail.visited_at) return <CBadge color="danger">Not Visited</CBadge>;
    if (detail.visited_at && !detail.check_in) return <CBadge color="danger">Not Visited</CBadge>;

    if (detail.visited_at && !detail.check_out) return <CBadge color="warning">Checked In</CBadge>;
    return <CBadge color="success">Completed</CBadge>;
  };
  async function fetchMainData({ dateFrom, dateTo, userID }) {
    const res = await getAll({
      dateFrom: dateFrom,
      dateTo: dateTo,
      userID: userID,
    });
    const rows =
      res.workPlans &&
      res.workPlans.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          name: item.userName,
          target: item.target,
          realization: item.realization,
          date: item.date ? formatter("dateOnly", item.date) : "",
          rawDate: item.date,
        };
      });
    //   {
    //     "id": 17,
    //     "target": 10,
    //     "user_id": 1,
    //     "date": "2025-05-12",
    //     "userName": "Harry",
    //     "realization": "3"
    // },
    setDataRows(rows);

    const columns = [
      { field: "no", headerName: "No", width: "50" },
      { field: "date", headerName: "Tanggal", flex: 1 },
      { field: "name", headerName: "Nama", flex: 1 },
      { field: "target", headerName: "Target", flex: 1 },
      { field: "realization", headerName: "Realisasi", flex: 1 },
    ];

    setDataColumns(columns);
  }
  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: "5px",
            width: "5px",
            borderRadius: "100%",
            background: "orange",
            position: "absolute",
            top: 2,
            right: 2,
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: "600",
          }}
        >
          {format(day, "d")}
        </span>
      </div>
    );
  }
  useEffect(() => {
    const newStartDay = formatter("SQLDate", dateRange[0].startDate);
    const newEndDay = formatter("SQLDate", dateRange[0].endDate);
    if ((refetch && renderCounter > 0) || renderCounter === 0) {
      fetchMainData({
        dateFrom: newStartDay,
        dateTo: newEndDay,
        userID: userID,
      });
      setRefetch(false);
    }
    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal, userID]);

  function handleRowClick(params) {
    setDetailModal(true);
    setSelectedWP(params.row);
    fetchDetails(params.row.id);
    console.log(params.row);
    // navigate("/user-actions", { state: params.row });
  }

  return (
    <div style={{ color: "black" }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? "red"} />
      <CModal size="xl" visible={detailModal} onClose={() => setDetailModal(false)}>
        <CModalHeader>
          Detail Rencana Kerja - {selectedWP.name} - {selectedWP.date}
        </CModalHeader>
        <CModalBody>
          <CTable>
            <CTableBody>
              <CTableRow>
                <CTableHeaderCell scope="row">Target</CTableHeaderCell>
                <CTableDataCell>{selectedWP.target}</CTableDataCell>
              </CTableRow>
              <CTableRow>
                <CTableHeaderCell scope="row">Realisasi</CTableHeaderCell>
                <CTableDataCell>{selectedWP.realization}</CTableDataCell>
              </CTableRow>
            </CTableBody>
          </CTable>
          <CCard>
            <CCardHeader>
              <strong>Visitation Details</strong>
            </CCardHeader>
            <CCardBody>
              <CTable striped hover responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col">#</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Toko</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Alamat</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Jam Rencana</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Check In</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Check Out</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Durasi</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {details.map((detail, index) => (
                    <CTableRow key={detail.id} onClick={() => handleVisitationClick(detail)}>
                      <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                      <CTableDataCell>{detail.store_name}</CTableDataCell>
                      <CTableDataCell>{detail.address}</CTableDataCell>
                      <CTableDataCell>{detail.hour}</CTableDataCell>
                      <CTableDataCell>{formatTime(detail.check_in)}</CTableDataCell>
                      <CTableDataCell>{formatTime(detail.check_out)}</CTableDataCell>
                      <CTableDataCell>{getVisitStatus(detail)}</CTableDataCell>
                      <CTableDataCell>{detail.duration} menit</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
            </CCardBody>
          </CCard>
        </CModalBody>{" "}
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : "",
          }}
        >
          <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => setDetailModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="xl" visible={visitationModal} onClose={() => setVisitationModal(false)}>
        <CModalHeader>Visitation Details - {selectedVisitation?.store_name}</CModalHeader>
        <CModalBody>
          {selectedVisitation && (
            <CRow>
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>Visit Details</strong>
                  </CCardHeader>
                  <CCardBody>
                    <CTable striped hover responsive>
                      <CTableBody>
                        <CTableRow>
                          <CTableHeaderCell scope="row">Store</CTableHeaderCell>
                          <CTableDataCell>{selectedVisitation.store_name}</CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                          <CTableHeaderCell scope="row">Address</CTableHeaderCell>
                          <CTableDataCell>{selectedVisitation.address}</CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                          <CTableHeaderCell scope="row">Check In</CTableHeaderCell>
                          <CTableDataCell>
                            {selectedVisitation.check_in || <CBadge color="secondary">Not checked in</CBadge>}
                          </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                          <CTableHeaderCell scope="row">Check Out</CTableHeaderCell>
                          <CTableDataCell>
                            {selectedVisitation.check_out || <CBadge color="secondary">Not checked out</CBadge>}
                          </CTableDataCell>
                        </CTableRow>
                        <CTableRow>
                          <CTableHeaderCell scope="row">Duration</CTableHeaderCell>
                          <CTableDataCell>
                            {selectedVisitation.check_in && selectedVisitation.check_out ? (
                              `${Moment(selectedVisitation.check_out).diff(
                                Moment(selectedVisitation.check_in),
                                "minutes"
                              )} minutes`
                            ) : (
                              <CBadge color="secondary">N/A</CBadge>
                            )}
                          </CTableDataCell>
                        </CTableRow>
                      </CTableBody>
                    </CTable>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => setVisitationModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Rencana Kerja </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: "right" }}>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel
                rows={dataRows}
                columns={dataColumns}
                excelName="Daftar WorkPlans"
                config={{ width: "20" }}
              />
            </CCol>
          </CRow>
          <CRow style={{ overflow: "scroll" }}>
            <CCol>
              <CButton
                className="ml-3 mb-3 btn btn-dark"
                style={{ backgroundColor: "#306fba", border: "none" }}
                hover="true"
                onClick={() => {
                  setDrModal(!drModal);
                }}
              >
                <div>
                  {Moment(dateRange[0].startDate).format("ll")}
                  {" - "}
                  {Moment(dateRange[0].endDate).format("ll")}
                </div>
              </CButton>
            </CCol>
          </CRow>
          <CModal visible={drModal}>
            <CModalHeader>
              {" "}
              <CModalTitle>Date Range</CModalTitle>
            </CModalHeader>
            <CModalBody>
              {" "}
              <CCol xs="12" lg="10">
                <DateRangePicker
                  onChange={(item) => {
                    setDateRange([item.range1]);
                    ls.set("dateRange", item.range1);
                  }}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={1}
                  maxDate={max}
                  ranges={dateRange}
                  direction="vertical"
                  weekStartsOn={1}
                  calendarFocus="backwards"
                  preventSnapRefocus={true}
                  rangeColors={["#4E5B97"]}
                  dayContentRenderer={customDayContent}
                />
              </CCol>
            </CModalBody>
            <CModalFooter
              style={{
                width: comparison < 1 ? `${(85 * 1) / comparison}vw` : "",
              }}
            >
              <CButton style={{ backgroundColor: "#4E5B97", border: "none" }} onClick={() => setDrModal(!drModal)}>
                Close
              </CButton>
              <CButton
                style={{ backgroundColor: "#4E5B97", border: "none" }}
                onClick={() => {
                  setRefetch(true);
                  setDrModal(false);
                }}
              >
                OK
              </CButton>
            </CModalFooter>
          </CModal>
        </CCardHeader>
        <div style={{ margin: "16px" }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            loading={loading}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: "center" }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default WorkPlans;
